export default __webpack_public_path__ + "static/media/Tesla-Fantom.87aa4471.png";